const config = {
  // BASE_URL: process.env.VUE_APP_API_URL || "http://goldenkey/api",
  BASE_URL:
    process.env.VUE_APP_API_URL || "https://api.goldenkey.marrar.co.mz/api",
  // process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api",
};

export default config;
